const STORAGE_KEY = "dams_product_compare_items";

export class ProductCompareStore {
  constructor({ toast, compareBaseUrl }) {
    this.toast = toast;
    this.compareBaseUrl = compareBaseUrl || "";
    this.items = this.read();

    this.compareBar = document.querySelector(".js-compare-bar");
    this.compareItems = document.querySelector(".js-compare-items");
    this.compareGo = document.querySelector(".js-compare-go");
    this.compareClear = document.querySelector(".js-compare-clear");
  }

  read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item) => ({
          id: Number(item?.id || 0),
          title: String(item?.title || "").trim(),
        }))
        .filter((item) => Number.isInteger(item.id) && item.id > 0)
        .slice(0, 4);
    } catch {
      return [];
    }
  }

  save() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items.slice(0, 4)));
  }

  isActive(id) {
    return this.items.some((item) => item.id === id);
  }

  toggle({ id, title }) {
    if (!id) return;

    if (this.isActive(id)) {
      this.items = this.items.filter((item) => item.id !== id);
      this.toast(`${title} karşılaştırmadan çıkarıldı.`, "info");
    } else {
      if (this.items.length >= 4) {
        this.toast("En fazla 4 ürün karşılaştırabilirsiniz.", "error");
        return;
      }
      this.items.push({ id, title });
      this.toast(`${title} karşılaştırmaya eklendi.`, "success");
    }

    this.save();
    this.render();
  }

  clear() {
    this.items = [];
    this.save();
    this.render();
  }

  bindGlobalActions() {
    if (this.compareClear && this.compareClear.dataset.boundCompare !== "1") {
      this.compareClear.dataset.boundCompare = "1";
      this.compareClear.addEventListener("click", (event) => {
        event.preventDefault();
        this.clear();
      });
    }

    if (document.body && document.body.dataset.boundCompareClear !== "1") {
      document.body.dataset.boundCompareClear = "1";
      document.body.addEventListener("click", (event) => {
        const target = event.target instanceof Element ? event.target.closest(".js-compare-clear") : null;
        if (!target) return;
        event.preventDefault();
        this.clear();
      });
    }
  }

  bindButtons(scope = document) {
    const buttons = Array.from(scope.querySelectorAll(".js-compare-toggle"));
    buttons.forEach((btn) => {
      if (btn.dataset.boundCompare === "1") return;
      btn.dataset.boundCompare = "1";

      btn.addEventListener("click", () => {
        const id = Number(btn.dataset.productId || 0);
        const title = btn.dataset.productTitle || "Ürün";
        this.toggle({ id, title });
      });
    });
  }

  render() {
    const buttons = Array.from(document.querySelectorAll(".js-compare-toggle"));
    buttons.forEach((btn) => {
      const id = Number(btn.dataset.productId || 0);
      const active = this.isActive(id);
      btn.classList.toggle("is-active", active);
      const icon = btn.querySelector("i");
      if (icon) icon.setAttribute("data-lucide", active ? "check" : "plus");
    });

    if (this.compareGo) {
      const ids = this.items.map((item) => item.id).join(",");
      const href = ids ? `${this.compareBaseUrl}?ids=${ids}` : this.compareBaseUrl;
      this.compareGo.setAttribute("href", href);
    }

    if (this.compareBar) {
      if (!this.items.length) {
        this.compareBar.hidden = true;
      } else {
        this.compareBar.hidden = false;
        if (this.compareItems) {
          this.compareItems.innerHTML = this.items
            .map((item) => `<span class=\"products-compare-bar__chip\">${item.title || `#${item.id}`}</span>`)
            .join("");
        }
      }
    }

    if (window.lucide?.createIcons) {
      window.lucide.createIcons();
    }
  }
}
